import units from 'units-css';

export const BASE_FONT_SIZE_VARIABLE_NAME = '--fl-base-font-size';

/**
 * PostCSS transformer that replaces all font sizes with a calculation expression that multiplies the normalization of
 * the original font size with a CSS variable containing the base font size. The CSS variable must be defined on a
 * higher-level element, and named --fl-base-font-size.
 */
export function findoRem() {
    return function (css) {
        css.walkDecls(function (decl) {
            if (decl.prop === 'font-size') {
                const fontSize = units.parse(decl.value);
                let normalizedFontSize = null;

                switch (fontSize.unit) {
                    case 'rem':
                        normalizedFontSize = fontSize.value;
                        break;
                    case 'px':
                        normalizedFontSize = fontSize.value / 16;
                        break;
                }

                if (normalizedFontSize !== null) {
                    decl.value = `calc(var(${BASE_FONT_SIZE_VARIABLE_NAME}) * ${normalizedFontSize})`;
                }
            }
        });
    };
}
